"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _colors = require("../../constants/colors");
var _ToastContext = require("./components/ToastContext");
var _ToastIconContainer = require("./styled/ToastIconContainer");
var _ToastStyled = require("./styled/ToastStyled");
const presets = {
  error: {
    iconComponent: _lodestarIcons.AlertErrorAltIcon,
    iconColor: _colors.neutralLight40,
    labelKey: "lbl_generic_error"
  },
  success: {
    iconComponent: _lodestarIcons.CheckFilledIcon,
    iconColor: _colors.neutralDark40,
    labelKey: "lbl_success"
  },
  warning: {
    iconComponent: _lodestarIcons.AlertWarningIcon,
    iconColor: _colors.neutralDark40,
    labelKey: "lbl_warning"
  },
  info: {
    iconComponent: _lodestarIcons.InfoFilledIcon,
    iconColor: _colors.neutralDark40,
    labelKey: "lbl_info"
  }
};
const getIcon = function (type) {
  let overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (overrides.Icon === null) {
    return null;
  }
  return overrides.Icon || presets[type].iconComponent;
};
const warnOnceOnDeprecatedToast = (0, _lodestarUtils.warnOnce)("Toast from @smartsheet/lodestar-core is deprecated. Please use @smartsheet/sds-toast-state-service instead." + " See https://static.smart.ninja/storybook/team-ui-engineering/lodestar-core/mainline/sds-toast-ui/storybook/index.html");

/**
 * @deprecated please use @smartsheet/sds-toast-state-service instead. See
 * https://static.smart.ninja/storybook/team-ui-engineering/lodestar-core/mainline/sds-toast-ui/storybook/index.html
 */
const Toast = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    type,
    components = {},
    clientId,
    ...rest
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    warnOnceOnDeprecatedToast();
  }
  const IconComponent = getIcon(type, components);
  const {
    iconColor
  } = presets[type];
  const memoizedToastContextValue = (0, _react.useMemo)(() => ({
    type
  }), [type]);
  return /*#__PURE__*/_react.default.createElement(_ToastContext.ToastContextProvider, {
    value: memoizedToastContextValue
  }, /*#__PURE__*/_react.default.createElement(_ToastStyled.ToastStyled, (0, _extends2.default)({
    type: type,
    role: "alert",
    "data-client-id": clientId,
    tabIndex: 0,
    ref: ref
  }, rest), IconComponent && /*#__PURE__*/_react.default.createElement(_ToastIconContainer.ToastIconContainer, {
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement(IconComponent, {
    color: iconColor
  })), children));
});
exports.Toast = Toast;
Toast.displayName = "Toast";
//# sourceMappingURL=Toast.js.map